import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { formattedMonth } from '../../../contexts/utils';
import { StatsListCon } from '../../Layouts/dashboard layouts/StatsListCon';
import { GlobalLoading } from '../../Layouts/GlobalLoading';

export const RidesPage = () => {
  const { rides, initLoading } = useContext(DashboardContext);
  const [monthRides, setMonthRides] = useState([]);

  useEffect(() => {
    const monthIndex = new Date().getMonth();

    if (rides) {
      const monthRides = [];
      rides.forEach((ride) => {
        if (ride.month - 1 === monthIndex) {
          monthRides.push(ride);
        }
      });
      setMonthRides(monthRides);
    }
  }, [rides]);

  return (
    <div className='main list'>
      <Helmet>
        <title>All Rides | LionTaxi Admin</title>
      </Helmet>
      {initLoading && (
        <div className='background-overlay active'>
          <GlobalLoading />
        </div>
      )}
      <header className='desktop'>
        <h2>Rides</h2>
      </header>
      <div className='cards list'>
        <div className='cards-info'>
          <div>
            <p>All Rides</p>
            <p>{rides.length}</p>
          </div>
          <div>
            <p>{formattedMonth} Rides</p>
            <p>{monthRides.length}</p>
          </div>
        </div>
      </div>
      <div className='stats-list'>
        <div className='stats-list-header'>
          <p>Passenger</p>
          <p>Ride Time</p>
          <p>Paid Amount</p>
          <p>Date</p>
        </div>
        <div className='stats-list-body'>
          {rides.map((ride) => (
            <StatsListCon user={false} key={ride.id} ride={ride} />
          ))}
        </div>
      </div>
    </div>
  );
};
